import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { DMHangSanXuat } from './dm-hang-san-xuat';
@Injectable()
export class DMHangSanXuatService {

    controller:string = 'DMHangSanXuat';
    constructor(private http: Http) { }
      
    GetList() {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + this.controller+'/GetList', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
               
    }

    GetListFromPagination(paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListPagination?currentPage="+ currentPage+"&maxSize="+ maxSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }

    GetItem(ids:string) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = ids;
        return this.http.post(Config.apiUrl + this.controller+'/GetItem', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
               
    }

    Save(item:DMHangSanXuat) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/thiet-bi/dm-hang-san-xuat/dm-hang-san-xuat.service.ts